import { render } from "./AddClaimComponent.vue?vue&type=template&id=fee42f1c"
import script from "./AddClaimComponent.vue?vue&type=script&lang=js"
export * from "./AddClaimComponent.vue?vue&type=script&lang=js"

import "./AddClaimComponent.vue?vue&type=style&index=0&id=fee42f1c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__